// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BenchmarkScatterChart_card__yw\\+Dj {
  padding: 24px 24px 18px;
  background: var(--bg-2, #fff);
  border-radius: 14px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);
}

.BenchmarkScatterChart_title__R24kX {
  margin: 0 0 10px;
  font-family: "Lora", "Georgia", serif;
  font-size: 20px;
  font-weight: 700;
  color: var(--text-1, #1a1a1a);
}

.BenchmarkScatterChart_subtitle__yCHgq {
  margin: 0 0 18px;
  font-size: 12px;
  color: var(--grey-text, #777);
  line-height: 1.45;
}

.BenchmarkScatterChart_chart__-sMDs {
  width: 100%;
  height: 520px;
}

.BenchmarkScatterChart_empty__uVtJb {
  padding: 20px 8px;
  font-size: 14px;
  color: var(--grey-text, #8a8a8a);
}

@media only screen and (max-width: 768px) {
  .BenchmarkScatterChart_card__yw\\+Dj {
    padding: 18px 14px 14px;
  }
  .BenchmarkScatterChart_title__R24kX {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/KeywordBenchmark/Components/BenchmarkScatterChart/BenchmarkScatterChart.module.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,6BAAA;EACA,mBAAA;EACA,wEAAA;AACF;;AAEA;EACE,gBAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,6BAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,aAAA;AACF;;AAEA;EACE,iBAAA;EACA,eAAA;EACA,gCAAA;AACF;;AAEA;EACE;IACE,uBAAA;EACF;EAEA;IACE,eAAA;EAAF;AACF","sourcesContent":[".card {\n  padding: 24px 24px 18px;\n  background: var(--bg-2, #fff);\n  border-radius: 14px;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.03);\n}\n\n.title {\n  margin: 0 0 10px;\n  font-family: \"Lora\", \"Georgia\", serif;\n  font-size: 20px;\n  font-weight: 700;\n  color: var(--text-1, #1a1a1a);\n}\n\n.subtitle {\n  margin: 0 0 18px;\n  font-size: 12px;\n  color: var(--grey-text, #777);\n  line-height: 1.45;\n}\n\n.chart {\n  width: 100%;\n  height: 520px;\n}\n\n.empty {\n  padding: 20px 8px;\n  font-size: 14px;\n  color: var(--grey-text, #8a8a8a);\n}\n\n@media only screen and (max-width: 768px) {\n  .card {\n    padding: 18px 14px 14px;\n  }\n\n  .title {\n    font-size: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `BenchmarkScatterChart_card__yw+Dj`,
	"title": `BenchmarkScatterChart_title__R24kX`,
	"subtitle": `BenchmarkScatterChart_subtitle__yCHgq`,
	"chart": `BenchmarkScatterChart_chart__-sMDs`,
	"empty": `BenchmarkScatterChart_empty__uVtJb`
};
export default ___CSS_LOADER_EXPORT___;
